import { PasswordResetFormErrors } from '@/fsd/entities/auth/model/types/PasswordResetFormErrors';

export const INITIAL_FORM_ERRORS: PasswordResetFormErrors = {
  email: '',
  general: '',
};
